// src/versionInfo.js
// Auto-generated by scripts/generateVersionInfo.js
// Do not edit manually.

export const versionInfo = {
  "appName": "CoreCompass",
  "version": "2.2.3",
  "buildNumber": 140,
  "buildDate": "2026-11-02T22:10:35.723Z",
  "gitBranch": "master",
  "gitCommit": "1dcf2b9",
  "gitCommitFull": "1dcf2b9adcd013eee99ca474b35a78dff3474a30"
};
